
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import { Button } from '@/components/ui/button';
import { Heart } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="min-h-[70vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-muted/30">
        <div className="text-center">
          <div className="mb-6">
            <Heart className="w-20 h-20 mx-auto text-pink-DEFAULT animate-pulse" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-4 bg-pink-gradient text-gradient">404</h1>
          <p className="text-2xl font-semibold mb-2">Page Not Found</p>
          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved to another location.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button onClick={() => navigate('/')}>
              Return to Home
            </Button>
            <Button variant="outline" onClick={() => navigate('/explore')}>
              Explore Profiles
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
